module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "gl-form",
    staticClass: "md-area js-vue-markdown-field",
    class: {
      'prepend-top-default append-bottom-default': _vm.addSpacingClasses
    }
  }, [_c('markdown-header', {
    attrs: {
      "preview-markdown": _vm.previewMarkdown
    },
    on: {
      "toggle-markdown": _vm.toggleMarkdownPreview
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.previewMarkdown),
      expression: "!previewMarkdown"
    }],
    staticClass: "md-write-holder"
  }, [_c('div', {
    staticClass: "zen-backdrop"
  }, [_vm._t("textarea"), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('markdown-toolbar', {
    attrs: {
      "markdown-docs-path": _vm.markdownDocsPath,
      "quick-actions-docs-path": _vm.quickActionsDocsPath
    }
  })], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.previewMarkdown),
      expression: "previewMarkdown"
    }],
    staticClass: "md md-preview-holder md-preview"
  }, [_c('div', {
    ref: "markdown-preview",
    domProps: {
      "innerHTML": _vm._s(_vm.markdownPreview)
    }
  }), _vm._v(" "), (_vm.markdownPreviewLoading) ? _c('span', [_vm._v("\n      Loading...\n    ")]) : _vm._e()]), _vm._v(" "), (_vm.previewMarkdown && !_vm.markdownPreviewLoading) ? [(_vm.referencedCommands) ? _c('div', {
    staticClass: "referenced-commands",
    domProps: {
      "innerHTML": _vm._s(_vm.referencedCommands)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.shouldShowReferencedUsers) ? _c('div', {
    staticClass: "referenced-users"
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-exclamation-triangle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n          You are about to add\n          "), _c('strong', [_c('span', {
    staticClass: "js-referenced-users-count"
  }, [_vm._v("\n              " + _vm._s(_vm.referencedUsers.length) + "\n            ")])]), _vm._v(" people to the discussion. Proceed with caution.\n        ")])]) : _vm._e()] : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "zen-control zen-control-leave js-zen-leave",
    attrs: {
      "href": "#",
      "aria-label": "Enter zen mode"
    }
  }, [_c('i', {
    staticClass: "fa fa-compress",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d90f78e"}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/markdown/field.vue
// module id = ../../../node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-7d90f78e"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/markdown/field.vue
// module chunks = common_vue